import { render, staticRenderFns } from "./StepTwoForm.vue?vue&type=template&id=84980548&"
import script from "./StepTwoForm.vue?vue&type=script&lang=js&"
export * from "./StepTwoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84980548')) {
      api.createRecord('84980548', component.options)
    } else {
      api.reload('84980548', component.options)
    }
    module.hot.accept("./StepTwoForm.vue?vue&type=template&id=84980548&", function () {
      api.rerender('84980548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/StepTwoForm.vue"
export default component.exports